/**
 * Abstract dialog component for downloading selected site information.
 */

const ID = 'aims_msp_selected-sites-panel_download-dialog';
const TEMPLATE = `
<div id="${ID}" class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Download</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <textarea rows="6" />
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
`;

export default class AbstractDownloadSelectedSitesDialog {

  constructor(options) {

    // Insert the template to render the list.
    $('body').append(TEMPLATE);
    const _$modalEl = $(`#${ID}`);

    // Render the selected sites to the TextArea.
    _$modalEl.find('textarea').val('Loading...');
    window.setTimeout(() => {
      _$modalEl.find('textarea').val(this.buildHtml(options));
    }, 1);

    // Display the dialog.
    _$modalEl.modal();

    // Clean up after close.
    _$modalEl.on('hidden.bs.modal', (e) => {
      _$modalEl.remove();
    });
  }

  buildHtml(options) {
    throw 'Not implemented.';
  }

}



// WEBPACK FOOTER //
// ./src/app/components/selected-sites-panel/dialogs/abstract-download-dialog.js